export { AntisocialPage as default } from '@/components/pages/Ir/Governance/Antisocial'
